export const MAX_TIMEOUT_MS = 0x7fffffff;

export function withTimeout(promise, ms, fallback) {
  const p = Promise.resolve(promise);
  if (!(ms > 0) || !Number.isFinite(ms) || ms > MAX_TIMEOUT_MS) return p.then((value) => ({ value, timedOut: false }));
  return new Promise((resolve, reject) => {
    let done = false;
    const timer = setTimeout(() => {
      if (done) return;
      done = true;

      try {
        resolve({ value: fallback(), timedOut: true });
      } catch (err) {
        reject(err);
      }
    }, ms);
    p.then(
      (value) => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        resolve({ value, timedOut: false });
      },
      (err) => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        reject(err);
      }
    );
  });
}
